var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-body"},[_c('iframe',{attrs:{"src":_vm.reportUrl,"height":"100%","width":"100%","frameborder":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }